import React from "react";
import { Button } from "@/components/Button";
import Sticky from "@/components/Sticky";
import { shopifyCartApi } from "@/services/shopifyCart";
import { useCartUiActions } from "../cart";
import { usePdpProduct, usePdpSellingPlan, usePdpVariant } from "./PdpContext";
import { productSelect, variantSelect } from "@/store";
import { useMediaQuery } from "@mui/material";
import theme from "@/theme";

const StickyAddToCartButton = () => {
  const shopifyCartAdder = shopifyCartApi.useTrackedAdd();
  const cartActions = useCartUiActions();
  const variant = usePdpVariant();
  const sellingPlan = usePdpSellingPlan();
  return (
    <Button
      className="h-full w-full grow bg-green-500 text-base text-primary not-disabled:hover:bg-green-900 not-disabled:hover:text-white lg:w-60 lg:grow-0"
      style={{ borderRadius: 0 }}
      onClick={() => {
        const lineItem = variantSelect.cartAddLineItem(variant, {
          subscription: sellingPlan,
        });

        const body = { items: [lineItem], sourceModule: "sticky_atc" };
        shopifyCartAdder.mutate(body, {
          onSuccess: () => cartActions.openDrawer(),
        });
      }}
    >
      Add to cart
    </Button>
  );
};

export const StickyAddToCart = () => {
  const product = usePdpProduct();
  const variant = usePdpVariant();
  const sellingPlan = usePdpSellingPlan();
  const isLargeScreen = useMediaQuery(
    theme.breakpoints.up(theme.breakpoints.values.lg)
  );
  const subscription = variantSelect.orderableSubscription(variant);
  if (!variant.available) {
    return null;
  }

  return (
    <Sticky
      displayThreshold={isLargeScreen ? 700 : 1000}
      anchor="bottom"
      timeout={100}
    >
      <div className="flex h-16 items-center bg-white lg:h-20 lg:pl-11">
        <div className="hidden grow items-center space-x-4 pr-12 lg:flex">
          <div className="flex h-12 items-center border-0 border-r border-solid border-primary-200 pr-4">
            <div className="text-lg font-semibold xl:text-2xl">
              {productSelect.name(product)}
            </div>
          </div>
          <div className="whitespace-nowrap border-0 border-r border-solid border-primary-200 pr-4">
            {productSelect.scent(product)}
          </div>
          <div className="whitespace-nowrap border-0 border-r border-solid border-primary-200 pr-4">
            {variantSelect.sizeFormat(variant)}
          </div>
          <div className="whitespace-nowrap">
            {subscription && sellingPlan ? "Subscription" : "One-time"}
          </div>
        </div>
        <div className="flex h-full grow items-center lg:grow-0">
          <div className="hidden pr-5 text-2xl font-semibold lg:block">
            {subscription && sellingPlan
              ? subscription.discount.price.format()
              : variant.price.format()}
          </div>
          <StickyAddToCartButton />
        </div>
      </div>
    </Sticky>
  );
};
